export default __webpack_public_path__ + "static/media/technicalIconEmpty.a727bbff.svg";